var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"api"}},[_c('div',{attrs:{"id":"filter"}},[_c('c-radio',{attrs:{"options":_vm.apis.map(function (v) { return ({
                label: v.name,
                value: v.hasOwnProperty('value') ? v.value : v.name,
            }); }),"defaultValue":_vm.selected},on:{"input":_vm.radioChange}})],1),_vm._v(" "),_c('div',{staticClass:"markdown-body",attrs:{"id":"introduce"}},[_c(_vm.compIntroduce,{tag:"component"})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afb1a7a6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Side.vue
// module id = null
// module chunks = 